export { default } from './JoinUsPopupContent';
